import { FC, SyntheticEvent } from "react";
import { Link } from "react-router-dom";

import Button from "web/Pages/PageGenerator/Button";

import LazyLoadImage from "web/Layout/Common/LazyLoadImage";

import { PropsWithClasses } from "web/types/Common";

import classify from "web/classify";

import defaultClasses from "./element.scss";

interface IElementProps {
  imageSrc: string;
  url: string;
  button: string;
  header: string;
  description: string;
  buttonFontColor: string;
  buttonBackgroundColor: string;
  backgroundColor: string;
  descriptionFontColor: string;
  headerFontColor: string;
  isLarge?: boolean;
  isMobile: boolean;
  onClick?: (prop: SyntheticEvent) => void;
  id: string;
  alt: string;
}

const PageGeneratorTripleElement: FC<PropsWithClasses<IElementProps>> = ({
  classes = {},
  imageSrc,
  url,
  button,
  header,
  description,
  buttonFontColor,
  buttonBackgroundColor,
  backgroundColor,
  descriptionFontColor,
  headerFontColor,
  isLarge = false,
  isMobile,
  onClick = () => {},
  id,
  alt,
}) => {
  const rootStyles = {
    color: descriptionFontColor,
    backgroundColor,
  };

  const headerStyles = {
    color: headerFontColor,
  };

  const imageWidth = 750;
  const imageHeight = isLarge ? 650 : 300;

  const titleId = `heading-${id}`;

  return (
    <section className={classes.root}>
      <Link
        to={url}
        style={rootStyles}
        data-t1="page_generator_triple_large"
        onClick={onClick}
        aria-labelledby={header ? titleId : undefined}
      >
        {imageSrc && (
          <LazyLoadImage
            className={classes.image}
            src={imageSrc}
            alt={alt}
            width={imageWidth}
            height={imageHeight}
          />
        )}
        <div className={classes.wrapper}>
          <div className={classes.content}>
            {header && (
              <h2
                className={classes.title}
                style={headerStyles}
                data-t1="page_generator_triple_large_title"
                id={titleId}
              >
                {header}
              </h2>
            )}
            {!isMobile && description && (
              <div
                className={classes.description}
                data-t1="page_generator_triple_large_description"
              >
                {description}
              </div>
            )}
          </div>
          <Button
            onClick={() => null}
            className={classes.button}
            buttonFontColor={buttonFontColor}
            buttonBackgroundColor={buttonBackgroundColor}
          >
            {button}
          </Button>
        </div>
      </Link>
    </section>
  );
};

export default classify<PropsWithClasses<IElementProps>>(defaultClasses)(
  PageGeneratorTripleElement
);
